/* Live supervision of the project's robots: the station list, the curves an RL practitioner
 * watches (episode return, interventions per episode) and the live event log. It moved here
 * from the old Supervision workspace because it is how a deployed robot is observed; the
 * people who answer a robot's call for help have their own workspace, Teleoperators.
 *
 * The event stream opens while these pages are open and closes when the person leaves, and
 * the link-down safety sentence is said above them, as it is above the help queue. */
import { Outlet, createFileRoute } from "@tanstack/react-router";

import { LinkDownBanner } from "../../../workspaces/fleet/components/LinkDownBanner";
import { useEventStream } from "../../../workspaces/fleet/live";

export const Route = createFileRoute("/_console/p/$org/$project/deploy/stations")({
  component: LiveSupervision,
});

function LiveSupervision() {
  useEventStream(true);
  return (
    <div className="flex h-full min-h-0 flex-col">
      <LinkDownBanner />
      <div className="min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
